<template>
  <b-container class="mt-4 py-2">
    <transition name="fade" mode="out-in">
      <b-row v-if="isDeliverSendOut" class="mb-5">
        <b-col md="8" offset-md="2" cols="12">
          <b-img src="../assets/shopping.png" center fluid></b-img>
          <h3 class="text-center text-success mt-3">您已成功送出訂單！</h3>
          <h4 class="mt-5">您的訂單編號為： {{deliverUqid}}</h4>
          <h4 class="mt-4">請於24小時內利用ATM轉帳至以下帳號</h4>
          <mark>(付款截止時間： {{moment().day(2).format('YYYY/MM/DD HH:mm:ss')}})</mark>
          <div class="bg-secondary text-light mt-2 p-4">
            <h4>匯款銀行代號：001</h4>
            <h4>匯款帳號：95175369852147</h4>
          </div>
          <h3 class="mt-4">若逾時付款，系統將自動取消訂單</h3>
          <b-row class="mt-5">
            <b-col md="6">
              <b-button variant="secondary" class="mt-2 w-100" size="lg" to="/">返回首頁</b-button>
            </b-col>
            <b-col md="6">
              <b-button class="mt-2 w-100 btn-pur-dark" size="lg" :to="`/deliver/${deliverId}`">詳細資訊</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-else class="pt-2 pb-5">
        <b-col md="6" cols="12">
          <h3 class="text-center">
            <span class="mark-bottom">購買人資訊</span>
          </h3>
          <b-form class="py-5 pr-5">
            <b-form-group id="buyer-name-fieldset" label-for="buyer-name">
              <template slot="label">
                <span class="text-danger">*</span>姓名
              </template>
              <b-form-input id="buyer-name" v-model="buyer.name" trim required form="checkout-form"></b-form-input>
            </b-form-group>
            <b-form-group id="buyer-school_num-fieldset" label-for="buyer-school_num">
              <template slot="label">
                <span class="text-danger">*</span>學號
              </template>
              <b-form-input id="buyer-school_num" v-model="buyer.school_num" trim required form="checkout-form"></b-form-input>
            </b-form-group>
            <b-form-group id="buyer-tel-fieldset" label-for="buyer-tel">
              <template slot="label">
                <span class="text-danger">*</span>電話
              </template>
              <b-form-input id="buyer-tel" v-model="buyer.tel" trim required form="checkout-form"></b-form-input>
            </b-form-group>
            <b-form-group id="buyer-email-fieldset" label-for="buyer-email">
              <template slot="label">
                <span class="text-danger">*</span>Email
              </template>
              <b-form-input id="buyer-email" type="email" v-model="buyer.email" trim required form="checkout-form"></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="6" cols="12">
          <h3 class="text-center">
            <span class="mark-bottom">取貨人資訊</span>
            <b-button size="sm" class="float-right btn-pur-mid" @click="onClickCopyBuyer">同購買人</b-button>
          </h3>
          <b-form class="py-5 pl-5">
            <b-form-group id="receiver-name-fieldset" label-for="receiver-name">
              <template slot="label">
                <span class="text-danger">*</span>姓名
              </template>
              <b-form-input id="receiver-name" v-model="receiver.name" trim required form="checkout-form"></b-form-input>
            </b-form-group>
            <b-form-group id="receiver-school_num-fieldset" label-for="receiver-school_num">
              <template slot="label">
                <span class="text-danger">*</span>學號
              </template>
              <b-form-input id="receiver-school_num" v-model="receiver.school_num" trim required form="checkout-form"></b-form-input>
            </b-form-group>
            <b-form-group id="receiver-tel-fieldset" label-for="receiver-tel">
              <template slot="label">
                <span class="text-danger">*</span>電話
              </template>
              <b-form-input id="receiver-tel" v-model="receiver.tel" trim required form="checkout-form"></b-form-input>
            </b-form-group>
            <b-form-group id="receiver-email-fieldset" label-for="receiver-email">
              <template slot="label">
                <span class="text-danger">*</span>Email
              </template>
              <b-form-input id="receiver-email" type="email" v-model="receiver.email" trim required form="checkout-form"></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col cols="12">
          <b-table :busy="isBusy" :items="list" :fields="fields" show-empty empty-text="未選擇商品" head-variant="light" outlined>
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(info)="scope">
              <b-row no-gutters>
                <!--b-col md="6">
                  <b-card-img lazy :src="scope.item.pic" class="rounded-0" :alt="scope.item.name"></b-card-img>
                </b-col-->
                <b-col md="12">
                  <h6 class="m-2">{{scope.item.name}}</h6>
                  <p class="m-2">{{scope.item.descript}}</p>
                </b-col>
              </b-row>
            </template>
            <template v-slot:cell(totally)="scope">
              ${{scope.item.price * scope.item.amount}}
            </template>
          </b-table>
        </b-col>
        <b-col cols="12" class="border-top mt-3">
          <h4 class="float-right mt-2">商品總計： <span class="text-danger">${{totalPrice}}</span></h4>
        </b-col>
        <b-col cols="12" class="mt-3">
          <h3>
            <span class="mark-bottom">付款方式</span>
          </h3>
          <b-form-radio-group v-model="selectedPayment" class="mt-5" form="checkout-form">
            <b-form-radio v-for="item in payOptions" :key="item.id" :value="item.value" size="lg">
              <b-card :title="item.name" :sub-title="item.mark" body-class="p-0" class="border-0"></b-card>
            </b-form-radio>
          </b-form-radio-group>
        </b-col>
        <b-col md="2" offset-md="10" cols="12" class="mt-3">
          <b-form id="checkout-form" @submit.prevent="onSubmit" class="text-right">
            <b-button type="submit" size="lg" :disabled="lockSendBtn" class="btn-pur-dark">送出訂單</b-button>
          </b-form>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>
<script>
import moment from 'moment'
import { State } from '../library/EventBus.js'
import { Payments } from '../library/Var.js'
export default {
  data () {
    return {
      moment,
      isDeliverSendOut: false,
      lockSendBtn: false,
      buyer: {
        name: '',
        school_num: '',
        email: '',
        tel: ''
      },
      receiver: {
        name: '',
        school_num: '',
        email: '',
        tel: ''
      },
      isBusy: false,
      list: [],
      totalPrice: 0,
      payOptions: [],
      selectedPayment: '',
      deliverId: '',
      deliverUqid: '',
    }
  },
  computed: {
    User () {
      return State.user
    },
    fields () {
      return [
        { key: 'info', label: '商品' },
        { key: 'size', label: '規格' },
        { key: 'price', label: '單價' },
        { key: 'amount', label: '數量' },
        { key: 'totally', label: '小計' }
      ]
    }
  },
  methods: {
    init () {
      const { name, school_num, tel, email } = this.User
      this.buyer = { name, school_num, tel, email }
      const options = Payments.map(item => {
        const { key, name, value, mark } = item
        return { id: key, value, name, mark }
      })
      this.payOptions = options
      const [ firstOpt ] = options
      if (firstOpt) {
        this.selectedPayment = firstOpt.value
      }
    },
    async fetch () {
      this.isBusy = true
      let total = 0
      try {
        const { data } = await this.$api.getCart()
        const wait = data.map(async item => {
          const { id, catalog: cid, size: sid, amount } = item
          const { data: catalog } = await this.$api.getProd(cid)
          const findSize = catalog.size.find(item => item.id === sid)
          const pics = catalog.pics
          pics.sort((a, b) => a.sort - b.sort)
          const obj = { id, cid, amount, price: catalog.price, name: catalog.name, descript: catalog.description, sid }
          const [ firstPic ] = pics
          if (firstPic) {
            obj.pic = this.$api.catalogImageLink(cid, firstPic.id)
          }
          total += catalog.price * amount
          if (findSize) {
            obj.size = findSize.name
          } else {
            obj.isError = true
          }
          return obj
        })
        if (!data.length) {
          this.lockSendBtn = true
        }
        this.list = await Promise.all(wait)
        this.totalPrice = total
      } catch (err) {
        console.log(err)
      }
      this.isBusy = false
    },
    onClickCopyBuyer () {
      const { name, school_num, tel, email } = this.User
      this.receiver = { name, school_num, tel, email }
    },
    async onSubmit () {
      const content = this.list.map(item => {
        const { cid: id, sid: size, amount } = item
        return { id, size, amount}
      })
      const pay_type = this.selectedPayment
      const receiver_info = this.receiver
      try {
        this.lockSendBtn = true
        const { data } = await this.$api.postDel({ content, pay_type, receiver_info })
        this.isDeliverSendOut = true
        this.deliverId = data.id
        this.deliverUqid = data.uqid
        this.$bus.$emit('update:cart')
      } catch (err) {
        console.log(err)
      }
    }
  },
  mounted () {
    this.init()
    this.fetch()
  }
}
</script>